import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import { getStoredData } from "../../json/fecthData";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const data = getStoredData(); // Retrieve configuration data
  const fields = data?.[2] || {}; // Use the third element of 'data', defaulting to an empty object if undefined

  useEffect(() => {
    // Check if the user session is still valid (i.e., not expired)
    const expirationTime = localStorage.getItem("expirationTime");
    if (expirationTime && new Date().getTime() > expirationTime) {
      // If the current time exceeds the expiration time, clear the session
      localStorage.removeItem("authenticated");
      localStorage.removeItem("expirationTime");
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails"); // Clear user details from localStorage
    }
  }, []);

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        "https://rohan-track-backend.vercel.app/user/login",
        {
          emailId: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.token && response.data.user) {
        const { token, user } = response.data;

        // 🧠 Save token and session
        localStorage.setItem("authenticated", "true");
        localStorage.setItem("token", token);
        const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem("expirationTime", expirationTime);

        // ✅ Store user details and permissions
        localStorage.setItem("userDetails", JSON.stringify(user));

        localStorage.setItem(
          "permissions",
          JSON.stringify(user.permissions || [])
        );
        localStorage.setItem(
          "fieldsAccess",
          JSON.stringify(user.fieldsAccess || [])
        );
        console.log("🧑 Logged-in User:", user);

        navigate("/");
      } else {
        setError(
          fields?.errorMessagesinvalidCredentials ||
            "Invalid username or password"
        );
      }
    } catch (err) {
      setError(
        fields?.errorMessagesinvalidCredentials ||
          "Invalid username or password"
      );
    }
  };

  // Function to get user details from localStorage (when needed)
  // const getUserDetails = () => {
  //   const userDetails = localStorage.getItem('userDetails');
  //   return userDetails ? JSON.parse(userDetails) : null;
  // };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-section">
          <img
            src={fields?.headerlogo || "./RohanBuildersLogo.png"}
            alt="Logo"
            className="login-logo"
          />
          <h2 className="login-heading">
            {fields?.headerwelcomeMessage || "Welcome Back"}
          </h2>
          <p className="login-subheading">
            {fields?.headersubheading ||
              "Enter To View Your Platform's Performance"}
          </p>

          <div className="form-group">
            <label className="form-label">
              {fields?.formemailLabel || "Email"}
            </label>
            <input
              type={fields?.formemailType || "text"}
              className="form-input"
              placeholder={
                fields?.formemailPlaceholder || "Enter Your mail Address"
              }
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              {fields?.formpasswordLabel || "Password"}
            </label>
            <input
              type={fields?.formpasswordType || "password"}
              className="form-input"
              placeholder={fields?.formpasswordPlaceholder || "Enter Password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="login-BelowLinks">
            <div className="remember-me">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  className="checkbox-input"
                  defaultChecked={fields?.formrememberMeChecked}
                />
                {fields?.formrememberMeLabel || "Remember Me"}
              </label>
            </div>
            <p
              className="forgot-password"
              onClick={() => navigate("/reset-password")}
              style={{
                cursor: "pointer",
                color: "var(--color-primary)",
                textDecoration: "underline",
              }}
            >
              {fields?.formforgotPasswordText || "Forgot Your Password?"}
            </p>
          </div>

          <button className="login-button" onClick={handleLogin}>
            {fields?.buttonslogin || "Login"}
          </button>

          {error && <p className="error">{error}</p>}

          <p className="login-buttonSeparator">Or, Login With</p>

          <button className="google-signup-button">
            {fields?.buttonsgoogleSignup || "Sign up With Google"}
          </button>
          <p className="register-link">
            {fields?.linksregisterText || "Don't have an account?"}{" "}
            <a
              href={fields?.linksregisterHref || "/register"}
              className="register-link-text"
            >
              {fields?.linksregisterLinkText || "Register Here"}
            </a>
          </p>
        </div>
      </div>

      <div className="design-side"></div>
    </div>
  );
};

export default Login;
